/* DD shipping-protection opt-in.
   Adds/removes the "shipping-protection" variant via the AJAX cart API when the
   customer toggles the checkbox. Opt-in only — nothing is ever added automatically.

   Re-render strategy mirrors dd-cart-crosssell.js: inside the drawer we hand the
   returned sections to the theme's <mini-cart> renderContents(); on the cart page
   we reload, since the cart page totals/line items are server-rendered and the
   theme has no public re-render hook for them. */
if (!customElements.get('dd-shipping-protection')) {
  class DDShippingProtection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = '1';
      this.input = this.querySelector('.dd-sp-input');
      this.variantId = Number(this.dataset.variantId);
      if (!this.input || !this.variantId) return;
      this.syncChecked();
      this.input.addEventListener('change', this.onToggle.bind(this));
    }

    /* Drives the visual selected state from a real class rather than :has(),
       so the styling can't silently fail on older browsers. */
    syncChecked() {
      this.classList.toggle('is-checked', this.input.checked);
    }

    /* Section ids the theme's mini-cart needs in order to re-render itself. */
    sectionIds() {
      const ids = [];
      const header = document.getElementById('header');
      if (header && header.dataset.id) ids.push(header.dataset.id);
      ids.push('header-mini-cart-content', 'header-mini-cart-footer');
      const dock = document.getElementById('mobile-dock');
      if (dock && dock.dataset.id) ids.push(dock.dataset.id);
      return ids.join(',');
    }

    setBusy(busy) {
      this.classList.toggle('is-loading', busy);
      this.input.disabled = busy;
    }

    onToggle() {
      const wantsProtection = this.input.checked;
      this.syncChecked();
      this.setBusy(true);

      const endpoint = wantsProtection ? '/cart/add.js' : '/cart/change.js';
      const payload = wantsProtection
        ? { items: [{ id: this.variantId, quantity: 1 }] }
        : { id: String(this.variantId), quantity: 0 };

      payload.sections = this.sectionIds();
      payload.sections_url = window.location.pathname;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((r) => r.json().then((body) => ({ ok: r.ok, body })))
        .then(({ ok, body }) => {
          if (!ok) throw new Error((body && body.description) || 'cart error');

          if (this.dataset.context === 'page') {
            window.location.reload();
            return;
          }

          const mc = document.querySelector('mini-cart');
          if (mc && typeof mc.renderContents === 'function' && body && body.sections) {
            mc.renderContents(body);
          } else {
            window.location.reload();
          }
        })
        .catch((e) => {
          console.error('dd-shipping-protection', e);
          /* Put the checkbox back where it was so it never lies about cart state. */
          this.input.checked = !wantsProtection;
          this.syncChecked();
          this.setBusy(false);
        });
    }
  }

  customElements.define('dd-shipping-protection', DDShippingProtection);
}
